module.exports = __webpack_public_path__ + "static/uat-sc-logo-2d1131fdf4265f773a9805fde7cda97f.png";